import { apiRequest, ReturnTypeWithPagination, VehicleFeaturedGetDTO, VehicleFeature } from "@alba-cars/common-modules";
import qs from "qs";

export const getVehicleFeatures = async (locale: "en" | "ar" | "ru" | "zh" = "en") => {
  const query = {
    options: {
      select: ["id", "name", "slug", "refId", "translations"],
      limit: 1000,
    },
  };
  const queryString = qs.stringify(query, {
    skipNulls: true,
    allowEmptyArrays: false,
    allowDots: false,
    arrayFormat: "repeat",
  });


  const endpoint = `/vehicle/features?${queryString}`;
  const response = await apiRequest<ReturnTypeWithPagination<VehicleFeature[]>>(endpoint, {
    headers: {
      "Accept-Language": locale,
    },
    next: {
      revalidate: 0,
      tags: ["vehicle-features"],
    },
  });

  return response;
};

export const getVehicleFeaturesOptions = async (
  _filters?: VehicleFeaturedGetDTO,
  options?: { locale?: "en" | "ar" | "ru" | "zh" },
): Promise<(VehicleFeature & { label: string; value: string })[]> => {
  const response = await getVehicleFeatures(options?.locale);

  const features = response.data?.result ?? [];

  return features.map((feature) => ({
    ...feature,
    label: feature.name,
    value: feature.id,
  }));
};
